/* Routes for sidebar menu
  For a single entry: {
    name: Entry Display Name,
    icon: Entry Icon,
    ID: dashboardRoutes.[route name].ID,
    path: dashboardRoutes.[route name].path,
  }

  For a folder: {
    name: Folder Display Name,
    icon: Folder Icon,
    ID: random ID for key for component in the loop,
    children: [{
      name: Sub entry name,
      path: dashboardRoutes.[route name].path,
    }],
  }
*/
import { CgProfile } from "react-icons/cg";
import { IoIosPeople } from "react-icons/io";
import { MdCampaign, MdBrandingWatermark } from "react-icons/md";
import { IoMdAnalytics } from "react-icons/io";
import { FaQuestionCircle } from "react-icons/fa";
import { GrObjectGroup } from "react-icons/gr";

import dashboardLayoutRoutes from "../../../router/router components/dashboardLayoutRoutes";

const routes = [
  // {
  //   name: "Profile",
  //   icon: CgProfile,
  //   ID: dashboardLayoutRoutes.profileDetailsRoute.ID,
  //   path: dashboardLayoutRoutes.profileDetailsRoute.path,
  // },

  // {
  //   name: "Quick Segments",
  //   icon: GrObjectGroup,
  //   ID: dashboardLayoutRoutes.readymadeCohorts.ID,
  //   path: dashboardLayoutRoutes.readymadeCohorts.path,
  // },

  {
    name: "Brands List",
    icon: MdBrandingWatermark,
    ID: dashboardLayoutRoutes.brandsAgencyList.ID,
    path: dashboardLayoutRoutes.brandsAgencyList.path,
  },

  {
    name: "Audience Cohorts",
    icon: IoIosPeople,
    ID: dashboardLayoutRoutes.audienceListRoute.ID,
    path: dashboardLayoutRoutes.audienceListRoute.path,
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.myCampaignRoute.ID,
    path: dashboardLayoutRoutes.myCampaignRoute.path,
  },

  // {
  //   name: "Reporting",
  //   icon: IoMdAnalytics,
  //   ID: dashboardLayoutRoutes.reportingRoute.ID,
  //   path: dashboardLayoutRoutes.reportingRoute.path,
  // },

  // {
  //   name: "Technical FAQ",
  //   icon: FaQuestionCircle,
  //   ID: dashboardLayoutRoutes.technicalFAQRoute.ID,
  //   path: dashboardLayoutRoutes.technicalFAQRoute.path,
  // },
];

export default routes;
